import api from "apis"

export default function* fetchLogin(loginData) {
  return yield api.post("/api/v10/login", loginData).then((result) => {
    console.log("LOGIN RESULTS", result)
    return result.data
  })
}
